var Backbone = require('backbone'),
    SearchOptions = require('./SearchOptions'),
    fvChannel = require('glRadio').channel('FV'),
    FRNoteModelConverter = require('./noteModelConverter');




module.exports = Backbone.Model.extend({

   defaults: {

       searchTerm: '',
       sanitizedSearchTerm: '',

       inResults: false, /* set to true if in the search results -- could just get from those in searchResults .... NOW NOT IN USE*/

       /* Now not exposed as options or in interface, though could be -- set from the Top Level Options */
       searchOptions: new SearchOptions(),
       noteModel: null, // not just the note type: may want to expose properties in the UI ( and potentially zone properties to )

       fromAPI: false, // provided on load vs entered manually

       isSelected: false // for now the 'non-collapsed' search ( always start false )

    },

    getNoteModel: function() {
        return this.get('noteModel');
    },

    setNoteModel: function( model ) {
        this.set( 'noteModel',  model );
    },

    setSearchTerms: function( rawSearchTerm ) {

        var searchOptions = this.get('searchOptions'),
            sanitizedSearchTerm = !searchOptions.get('ignoreCertainCharacters')
                ? rawSearchTerm
                : rawSearchTerm.replace( searchOptions.getCharactersToIgnoreReg(), '' );
        /**
         * Trim:
         *  Remove extraneous spaces at the end of the search
         *  Also serves to prevent searching for a ' ', which would result in a hit on every word and block the browser.
         *  Though ' ' is not a character to ignore -- we need spaces to determine the words to search.
         */
        sanitizedSearchTerm = sanitizedSearchTerm.trim();

        this.set({
            searchTerm: rawSearchTerm,
            sanitizedSearchTerm: sanitizedSearchTerm
        });

    },


    /* If the user entered anything, leave it -- otherwise make the search */
    setNoteSubjectOnSearch: function() {

        var note = this.getNoteModel(),
            noteTitle = note.get('title'); // TODO: get subj on note base model is display specific; change that ...

        // TODO: depending on research, the user could change it ... but now after the search it is disabled ...

        if ( !noteTitle || noteTitle.length < 1 ) {

            note.set( 'title', this.get('searchTerm').substring( 0, fvChannel.request('getPageNoteTitleMaxLength') ) );
        }

    },

    /**
     * Prevent hitting search on the form and now from findAndRedactOnEntry.
     *  Allow search if sanitizedSearchTerm has more than 1 character.
     *  If only 'ignored characters' are entered -- a search would like hang the browser,
     *  since every word would be a hit.
     *  Essentially a 'derived' model attribute
     *  TODO: maybe workflow changes here with reset ... and now this is like a 'validate'
     * */
    isValid: function() {

        var sanitizedSearchTerm = this.get('sanitizedSearchTerm');

        return sanitizedSearchTerm.length > 0;

    },

    /* Quick hack to see if changed on edit from prior search -- now not 100% fully accurate, just getting what is needed */
    isTheSameAsOtherSearch: function( search ) {

        if ( this.get('searchTerm') !== search.get('searchTerm') ) {
            return false;
        }

        if ( FRNoteModelConverter.didNoteChange( this.getNoteModel(), search.getNoteModel() ) ) {
            return false;
        }

        return true;

    },

    /* Now used for edit -- not overwriting BB clone now */
    getClone: function() {

        var clonedNote = this.getNoteModel().clone( { parse:true} );
        var clonedShape = FRNoteModelConverter.cloneShapeModel( clonedNote, this.getNoteModel().shape );
        clonedNote.shape = clonedShape;

        var clone = this.clone(); // would prob want override at the model level
        clone.setNoteModel( clonedNote );

        return clone;
    },

    updateLocalStorageForRedactionNotes: function() {

        if ( this.getNoteModel().isRedactionNote() ) {
            this.getNoteModel().shape.updateLocalStoragePostDialogClose();
        }

    }




});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/SearchModel.js
 ** module id = 582
 ** module chunks = 0
 **/